// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"fba558a5","513":"b3f379a1","703":"0f35c5fc","787":"970666e9"}[chunkId] + ".chunk.js";
};